module.exports = __webpack_public_path__ + "static/media/physician-bill-pay.ba3a124c.png";